<template>
  <!--{'pt-100':$route.path.indexOf('opt5') >= 0, 'pt-210': $route.path.indexOf('opt6') >=0, 'pt-250': $route.path.indexOf('opt2') >=0, 'pt-120': $route.path.indexOf('opt') < 0}-->
  <div id="cpn-home-popular">
    <!--<span>{{$t('home.button_our_most_popular_deals')}}</span>-->
     <div v-if="isMoveTips" class="flex flex-column xs-flex-center xs-my-20 xs-mx-10 xs-mb-20 t16 p-20 text-white" style="background: red; ">
      <div>{{$t('no_touch_title')}}</div>
      <div>
        <router-link to="/notouch" class=" button mt-10" hreflang="en-MY" style="    background: white;color: red;margin-top: 15px;">
          {{$t('learn_more_button')}}
        </router-link>
      </div>
    </div>

    <h2 class="caps xs-my-20 xs-mx-10 xs-mb-10 mt-10 xs-text-center heading-hr font-light font-sharp-sans-bold">{{$t('home.button_our_most_popular_deals')}}</h2>
    <div class="md-flex md-justify-center md-pb-10 lg-container banner-home">
      <a href="javascript: void(0)" @click="handleClickItem('left', left.url)"
         v-if="left && left.image.desktop"
         class="xs-block p10 decoration-none xs-full-width" data-synth="first-deal">
        <img v-bind:src="isMobile() ? left.image.mobile : left.image.desktop"
             data-synth="home-promo--5-favourite-single-5" class="xs-block xs-full-width" alt="">
        <button v-if="orderNow"
                class="order-now">
          {{ $t('order_now') }}
        </button>
        <div class="xs-text-center xs-text-gray-lightest xs-fill-gray-darkest xs-opacity-90 typo-l8"></div>
      </a>

      <a href="javascript: void(0)" @click="handleClickItem('right', right.url)"
         v-if="right && right.image.desktop"
         class="xs-block p10 decoration-none xs-full-width" data-synth="first-deal">

        <img v-bind:src="isMobile() ? right.image.mobile : right.image.desktop"
             data-synth="home-promo--5-favourite-single-5" class="xs-block xs-full-width" alt="">
        <button v-if="orderNow"
                class="order-now">
          {{ $t('order_now') }}
        </button>
        <div class="xs-text-center xs-text-gray-lightest xs-fill-gray-darkest xs-opacity-90 typo-l8"></div>
      </a>
    </div>
    <div class="xs-px-10 xs-mb-40 lg-container text-center">
      <div class="btn-home-view">
        <a href="javascript: void(0)" @click="handleClickItem('bottom', $const.MENU_DEFAULT)"
           class="button button--primary button--xl xs-mb-20 text-white-hover btn-view-left" id="btn-view-all-deal-element-left"
           data-synth="home-link--moredeals"
        ><span><span>{{ $t('home.button_view_all_deal')}} </span></span></a>
      </div>
      <div class="my-20">
        <router-link :to="{name: 'hut-rewards'}">
          <img src="https://static.phdvasia.com/my/banners/hut-reward-banner-2-white_20191004.jpg" alt="">
        </router-link>
      </div>
      <!--<div class="home-coupon"-->
      <!--v-on:click.stop="redirectToMenuPage($const.HEADER_MENU.COUPON)">-->
      <!--<img src="https://static.phdvasia.com/my/images/coupon-bg.jpg" class="bg"/>-->
      <!--<div class="inner">-->
      <!--<div class="text-wrap">-->
      <!--<span>{{ $t('your_coupon') }}</span>-->
      <!--</div>-->
      <!--<a v-on:click.stop="redirectToMenuPage($const.HEADER_MENU.COUPON)">-->
      <!--{{ $t('view_coupon') }}-->
      <!--</a>-->
      <!--</div>-->
      <!--</div>-->
    </div>

    <h2 class="caps xs-my-20 xs-mx-10 xs-mb-10 mt-10 xs-text-center heading-hr font-light font-sharp-sans-bold">{{$t('home.button_our_dine_in_restaurants')}}</h2>
    <div class="lg-container">
      <a href="https://www.pizzahut.com.my/find-a-hut" target="_blank" rel="noopener" class="xs-block xs-p-10 xs-mb-20 decoration-none">
        <div class="xs-px-20 xs-py-20 load-background-img" data-background="https://static.phdvasia.com/my/banners/DineInPromo.jpg" data-background-mobile="https://static.phdvasia.com/my/fcds/backgrounds/DineInPromo-mobile.png" style="background-image: url(&quot;https://static.phdvasia.com/my/fcds/backgrounds/DineInPromo.jpg&quot;);">
          <div class="xs-flex xs-flex-wrap xs-items-center xs-justify-center xs-fill-white xs-px-20 xs-py-15 xs-mx-auto rounded max-width-640">
            <div class="xs-mb-10 md-mb-0 md-mr-20 xs-grow-0 xs-shrink-1 flex-basis-280">
              <img src="https://static.phdvasia.com/my/banners/DineInPromoHeader.jpg" class="xs-align-middle full-width" alt="Dine In" title="Dine In" width="411">
            </div>
            <button class="button button--yellow xs-grow-1 xs-shrink-0 xs-text-center flex-basis-50-per"><span><span>Find a Restaurant</span></span>
            </button>
          </div>
        </div>
      </a>
    </div>

    <div v-if="!isMoveTips" class="flex flex-column xs-flex-center xs-my-20 xs-mx-10 xs-mb-20 t16 p-20 text-white" style="background: #C8102E; ">
      <div>{{$t('no_touch_title')}}</div>
      <div>
        <router-link to="/notouch" class=" button mt-10" hreflang="en-MY" style="    background: white;color: #C8102E;margin-top: 15px;">
          {{$t('learn_more_button')}}
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    props: ['orderNow','isMoveTips'],
    computed: {
      ...mapGetters({
        categoryList: 'categoryList'
      })
    },
    mounted() {
      this.getBanners()
    },
    data() {
      return {
        left: {
          image: {
            desktop: '',
            mobile: ''
          },
          url: ''
        },
        right: {
          url: '',
          image: {
            desktop: '',
            mobile: ''
          }
        }
      }
    },
    methods: {
      handleClickItem(type, url) {
        let data = {
          id: 'pop-home',
          moduleId: ''
        }
        if (type == 'bottom') {
          data.id = 'all-home'
          data.moduleId = 'all-home-1'
          if (this.$const.MENU_DEFAULT != url) {
            data.moduleId = 'all-home-2'
          }
          this.eventTrackingModuleItemClick(data)
          this.redirectToPage([url])
          return false
        } else {
          if (type == 'left') {
            data.moduleId = this.left.name.split(' ').join('-')
          } else if (type == 'right') {
            data.moduleId = this.right.name.split(' ').join('-')
          }
          this.eventTrackingModuleItemClick(data)
        }

        if (url) {
          this.redirectToUrl(url, true)
        } else {
          this.redirectToPage(this.$const.SLUG_LIST.PIZZA)
        }
      },
      getBanners() {
        var vm = this
        this.axios.apiBanners.getBannersByPosition('?code=right_home,left_home,top_home_web', respone => {
          let data = respone.data.data.item
          let left_image = data.left_home
          let right_image = data.right_home
          if (typeof left_image !== 'undefined') {
            vm.left.image.desktop = left_image[0].image.desktop
            vm.left.image.mobile = left_image[0].image.mobile
            vm.left.url = left_image[0].url.desktop
            vm.left.name = typeof left_image[0].name == 'string' ? left_image[0].name : left_image[0].name[vm.$session.get('lang')]
          }
          if (typeof right_image !== 'undefined') {
            vm.right.image.desktop = right_image[0].image.desktop
            vm.right.image.mobile = right_image[0].image.mobile
            vm.right.url = right_image[0].url.desktop
            vm.right.name = typeof right_image[0].name == 'string' ? right_image[0].name : right_image[0].name[vm.$session.get('lang')]
          }
          if (data.top_home_web && data.top_home_web.length > 0) {
            const topHeader = document.getElementById('home-localise-cta')
            const topHeaderMobile = document.getElementById('banner-mobile')
            const topURLDesktop = document.getElementById('top-url')
            if (window.matchMedia('(max-width: 768px)').matches) {
              const topUrlMobile = document.getElementById('top-url-mobile')
              topHeaderMobile.src = data.top_home_web[0].image.mobile
              let urlMobile = data.top_home_web[0].url.mobile
              if (urlMobile) {
                topUrlMobile.href = urlMobile
              }
            } else {
              topHeader.style.backgroundImage = `url('${data.top_home_web[0].image.desktop}')`
              topHeader.style.backgroundSize = 'cover'
              topHeader.style.backgroundPosition = 'center'
              let urlDesktop = data.top_home_web[0].url.desktop
              if(urlDesktop) {
                topURLDesktop.href = urlDesktop
                topURLDesktop.style.cursor = 'pointer'
              }
            }
          }
          let h = document.getElementById('btn-view-all-deal-element-left').offsetHeight
          let w = document.getElementById('btn-view-all-deal-element-left').offsetWidth
          let layer = {
            'modules': [],
            'assets': {
              'products': [],
              'promotions': [
                {
                  'id': 'all-home-1',
                  'name': 'view-all-deals',
                  'creative': {
                    'id': 'all-home-1-creative',
                    'type': 'internal'
                  },
                  'attributes': {
                    'size': w + 'x' + h,
                    'destination': window.location.origin + '/order'
                  }
                }
              ]
            }
          }
          let pop = {
            'id': 'pop-home',
            'name': 'most-popular-deals',
            'type': 'merchandising',
            'placement': 'home-promo-slots',
            'items': []
          }
          let prods = []
          if (vm.left.hasOwnProperty('name')) {
            let lname = vm.left.name.split(' ').join('-')
            pop.items.push({
              'id': lname,
              'type': 'product',
              'position': '1'
            })
            prods.push({
              'id': lname,
              'name': lname,
              'category': 'deal',
              'variants': [],
              'value': {},
              'tax': {
                'type': '',
                'name': '',
                'size': '0'
              },
              'purchaseMethod': 'main'
            })
          }
          if (vm.right.hasOwnProperty('name')) {
            let rname = vm.right.name.split(' ').join('-')
            pop.items.push({
              'id': rname,
              'type': 'product',
              'position': '2'
            })
            prods.push({
              'id': rname,
              'name': rname,
              'category': 'deal',
              'variants': [],
              'value': {
                'displayGross': '0',
                'displayTax': '0'
              },
              'tax': {
                'type': '',
                'name': '',
                'size': '0'
              },
              'purchaseMethod': 'main'
            })
          }
          layer.assets.products = prods
          layer.modules.push(pop)
          layer.modules.push({
            'id': 'all-home',
            'name': 'all-deals',
            'type': 'promotions',
            'placement': 'home-promo-bottom',
            'items': [
              {
                'id': 'all-home-1',
                'type': 'promotion',
                'position': '1'
              }
            ]
          })
          vm.$root.$emit('onTrackingHomepage', layer)
        }, error => {
          console.log('error', error)
        })
      }
    }
  }

</script>
<style scoped>
  .flex-basis-280 {
    flex-basis: 280px;
  }
  .flex-basis-50-per {
    flex-basis: 50%;
  }
  .max-width-640{
    max-width: 640px
  }

  .pt-210 {
    padding-top: 210px !important;
  }

  .pt-120 {
    padding-top: 120px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/home/HomePopularDeal.vue